export type MeshFormat = "obj" | "stl" | "glb" | "gltf" | "3mf" | "msh";

const EXTENSION_MAP: Record<string, MeshFormat> = {
  obj: "obj",
  stl: "stl",
  glb: "glb",
  gltf: "gltf",
  "3mf": "3mf",
  msh: "msh",
};

export function meshFormatFromExtension(ext: string): MeshFormat | undefined {
  return EXTENSION_MAP[ext.replace(/^\./, "").toLowerCase()];
}
